import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'calsoft-affiliate-section',
  templateUrl: './affiliate-section.component.html',
  styleUrls: ['./affiliate-section.component.scss']
})
export class AffiliateSectionComponent {
  @ViewChild('backgroundVideo') videoRef!: ElementRef<HTMLVideoElement>;

  ngAfterViewInit() {
    this.setupVideoAutoplay();
  }

  private setupVideoAutoplay() {
    const video = this.videoRef.nativeElement;
    
    // Modern browsers require promise-based play
    const playPromise = video.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        // Autoplay was prevented - mute and try again
        video.muted = true;
        video.play().catch(e => console.log('Autoplay prevented:', e));
      });
    }
  }
}
